import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import Row, { Slot } from './row'
import PlanCard from './plan-card'
import styles from '../component-styles/plans.module.scss'
import Layout from './layout'
import EnterpriseCard from './enterprise-card'
import ToggleButton from './annual-toggle-button'
import { getAvailableSubscriptions } from '../api-client/billing-client'
// import { useHistory } from 'react-router';
import { getSelectedAccountAsync } from '../store/actions'

const DEV = process.env.REACT_APP_PROD !== 'TRUE'
const PROD = process.env.REACT_APP_PROD === 'TRUE'

const fetchPlans = async (setPlans: (plans: any) => void): Promise<void> => {
  const nextPlans: any = await getAvailableSubscriptions()
  if (nextPlans?.length > 0) {
    setPlans(nextPlans)
  }
}

interface Props {
  title?: string
}

export default function Plans({ title = 'Choose your plan' }: Props) {
  const dispatch = useDispatch()

  // const history = useHistory();
  const [plans, setPlans] = useState([])
  const [annual, setAnnual] = useState(false)

  // useEffect(() => {
  //   (async () => {
  //     const res = await checkBillingState()
  //   })()
  // }, [history, checkBillingState])

  useEffect((): void => {
    if (plans.length > 0) return
    fetchPlans(setPlans)
  }, [plans, setPlans])

  useEffect((): void => {
    dispatch(getSelectedAccountAsync())
    // eslint-disable-next-line
  }, [])

  const filteredPlans = useMemo(
    (): any =>
      plans.reduce((acc: any, plan: any): any => {
        const billingDateRange = annual ? 'year' : 'month'
        if (plan.billing_type !== billingDateRange) return acc

        if (plan.id === 583196 && DEV) {
          acc.collaboration = {
            ...plan,
            price: plan.recurring_price.GBP,
            planType: 'collaboration',
          }

          acc.solo = {
            ...plan,
            price: plan.recurring_price.GBP,
            planType: 'solo',
          }
        }

        if ((plan.id === 580852 || plan.id === 580851) && PROD) {
          acc.collaboration = {
            ...plan,
            price: plan.recurring_price.GBP,
            planType: 'collaboration',
          }
        }

        if ((plan.id === 580191 || plan.id === 580194) && PROD) {
          acc.solo = {
            ...plan,
            price: plan.recurring_price.GBP,
            planType: 'solo',
          }
        }

        return acc
      }, {}),
    [plans, annual],
  )

  if (plans.length <= 0) return null

  return (
    <Layout width={768}>
      <Row align="center">
        <Slot align="center">
          <h1 className={styles.title}>{title}</h1>
        </Slot>
      </Row>
      <Row align="center">
        <Slot align="center">
          <ToggleButton checked={annual} onChange={setAnnual} />
        </Slot>
      </Row>
      <Row align="center">
        <Slot padding="16px" align="flex-end" className={styles.cards}>
          <PlanCard plan={filteredPlans.solo} style={{ margin: 0 }} />
        </Slot>
        <Slot padding="16px" align="flex-start" className={styles.cards}>
          <PlanCard plan={filteredPlans.collaboration} style={{ margin: 0 }} />
        </Slot>
      </Row>
      <Row>
        <Slot padding="16px" align="center">
          <EnterpriseCard />
        </Slot>
      </Row>
    </Layout>
  )
}
